<template>
  <div id="app" :class="openMenus ? 'fixedHeight' : ''">
    <!-- PC导航栏 -->
    <div class="menus_header" v-if="device == 'PC'">
      <div class="header_left" @click="handelJump('/')">
        <img :src="'http://124.223.178.182:8090' + webSiteInfo.logo" alt />
      </div>
      <div class="header_search">
        <div :class="openSearch ? 'searchMain open' : 'searchMain'">
          <!-- <div class="icon" @click="handelOpenSearch" v-if="!openSearch">
            <img src="./assets/images/search.png" alt="" />
          </div>-->
          <input
            v-if="openSearch"
            @focus="handelOpenSearch"
            @keyup.enter="handelSearch"
            ref="searchInput"
            class="searchInp"
            type="text"
            v-model="searchKey"
          />
          <div class="icon_clear" v-if="openSearch" @click="clearSearch">x</div>
          <div class="icon" v-if="openSearch" @click="handelSearch">
            <img src="./assets/images/search.png" alt />
          </div>
          <!-- <div class="closeSearch" v-if="openSearch" @click="handelCloseSearch">x</div> -->
        </div>
      </div>
      <div class="search_close" v-if="openSearch" @click="handelCloseSearch">
        {{ baseLabel["关闭"][language] }}
      </div>
      <div class="menus_list" v-if="!openSearch">
        <div
          v-for="(item, index) in menus"
          :key="index"
          class="menus_item"
          @click="handelJump(item.path)"
        >
          {{ baseLabel[item.label][language] }}
        </div>
        <div class="menus_item" @click.stop="handelLanguage">中/EN</div>
      </div>
      <div class="header_icon" @click="handelOpenSearch" v-if="!openSearch">
        <img src="./assets/images/search.png" alt />
      </div>
    </div>
    <!-- 固定PC端导航栏 -->
    <div class="menus_headerFixed FixedTop" v-if="isScorll && device == 'PC'">
      <div class="header_left" @click="handelJump('/')">
        <img :src="'http://124.223.178.182:8090' + webSiteInfo.logo" alt />
      </div>
      <div class="header_search">
        <div :class="openSearch ? 'searchMain open' : 'searchMain'">
          <!-- <div class="icon" @click="handelOpenSearch" v-if="!openSearch">
            <img src="./assets/images/search.png" alt="" />
          </div>-->
          <input
            v-if="openSearch"
            @focus="handelOpenSearch"
            ref="searchInput"
            class="searchInp"
            type="text"
            v-model="searchKey"
          />
          <div class="icon_clear" v-if="openSearch" @click="clearSearch">x</div>
          <div class="icon" v-if="openSearch" @click="handelSearch">
            <img src="./assets/images/search.png" alt />
          </div>
        </div>
      </div>
      <div class="search_close" v-if="openSearch" @click="handelCloseSearch">
        {{ baseLabel["关闭"][language] }}
      </div>
      <div class="menus_list" v-if="!openSearch">
        <div
          v-for="(item, index) in menus"
          :key="index"
          class="menus_item"
          @click="handelJump(item.path)"
        >
          {{ baseLabel[item.label][language] }}
        </div>
        <div class="menus_item" @click="handelLanguage">中/EN</div>
      </div>
      <div class="header_icon" @click="handelOpenSearch" v-if="!openSearch">
        <img src="./assets/images/search.png" alt />
      </div>
    </div>

    <!-- 移动端导航栏 -->
    <div class="mobile_menus_header" v-if="device == 'MOBILE'">
      <div class="header_left" @click="handelJump('/')">
        <img :src="'http://124.223.178.182:8090' + webSiteInfo.logo" alt />
      </div>
      <div :class="openMenus ? 'header_right noBorder' : 'header_right'">
        <div class="menus_icon" @click="handelOpenMenus" v-if="!openMenus">
          <div class="line_top"></div>
          <div class="line_bottom"></div>
        </div>
        <div class="menus_close" @click="handelCloseMenus" v-if="openMenus">
          X
        </div>
      </div>
    </div>

    <!-- 移动端固定导航栏 -->
    <div
      class="mobile_menus_header_fixed"
      v-if="isScorll && device == 'MOBILE'"
    >
      <div class="header_left" @click="handelJump('/')">
        <img :src="'http://124.223.178.182:8090' + webSiteInfo.logo" alt />
      </div>
      <div class="header_right">
        <div class="menus_icon" @click="handelOpenMenus" v-if="!openMenus">
          <div class="line_top"></div>
          <div class="line_bottom"></div>
        </div>
        <div class="menus_close" @click="handelCloseMenus" v-if="openMenus">
          X
        </div>
      </div>
    </div>

    <!-- 移动端开启的菜单 -->
    <div
      :class="
        openMenus
          ? 'fixed_menus_body open_fixed_menus_body'
          : 'fixed_menus_body'
      "
      v-if="device == 'MOBILE'"
    >
      <div class="mobile_menus_item" @click="handelSearch">
        <img style="width: 30px" src="./assets/images/search.png" alt />
      </div>
      <div class="mobile_menus_box">
        <div
          class="mobile_menus_item"
          v-for="(item, index) in menus"
          @click="handelJump(item.path)"
          :key="index"
        >
          {{ baseLabel[item.label][language] }}
        </div>

        <div class="mobile_menus_item" @click.stop="handelLanguage">中/EN</div>
      </div>
      <!-- <div class="mobile_address">
        <div class="mobile_address_item">
          <div class="item_title">{{ baseLabel["开放时间"][language] }}</div>
          <div class="content">{{ webSiteInfo.openTime }}</div>
        </div>
        <div class="mobile_address_item">
          <div class="item_title">{{ baseLabel["联系我们"][language] }}</div>
          <div class="content">
            <div>
              {{ baseLabel["电话"][language] }}：{{ webSiteInfo.phone }}
            </div>
            <div>
              {{ baseLabel["邮箱"][language] }}：{{ webSiteInfo.email }}
            </div>
          </div>
        </div>
        <div class="mobile_address_item">
          <div class="item_title">{{ baseLabel["地址"][language] }}</div>
          <div class="content">{{ webSiteInfo.address }}</div>
        </div>
      </div> -->
      <div class="mobile_flooter" v-animate="'fadeIn'">
        <div class="icon">
          <img src="./assets/images/x2.png" alt />
          <div class="ewm">
            <img
              :src="'http://124.223.178.182:8090' + webSiteInfo.wechat"
              alt
            />
          </div>
        </div>
        <div class="icon" @click="handelJumpLink(webSiteInfo.redbook)">
          <img src="./assets/images/x3.png" alt />
        </div>
        <div class="icon" @click="handelJumpLink(webSiteInfo.instagram)">
          <img src="./assets/images/x1.png" alt />
        </div>
        <div class="technology">
          <!-- {{ baseLabel["技术支持"][language] }}: 15587883508 -->
        </div>
      </div>
    </div>
    <!-- 中间路由模块 -->

    <div class="route_body">
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </div>
    <!-- PC端底部 -->
    <div class="flooter_body">
      <div class="flooter">
        <div class="flooter_item" v-animate="'fadeIn'">
          <div class="title">{{ baseLabel["开放时间"][language] }}</div>
          <div class="content">
            <div>{{ webSiteInfo.openTime }}</div>
            <!-- <div>星期二 至 星期六</div> -->
          </div>
        </div>
        <div class="flooter_item" v-animate="'fadeIn'">
          <div class="title">{{ baseLabel["联系我们"][language] }}</div>
          <div class="content">
            <div>
              {{ baseLabel["电话"][language] }}：{{ webSiteInfo.phone }}
            </div>
            <div>
              {{ baseLabel["邮箱"][language] }}：{{ webSiteInfo.email }}
            </div>
            <div></div>
          </div>
        </div>
        <div class="flooter_item" v-animate="'fadeIn'">
          <div class="title">{{ baseLabel["地址"][language] }}</div>
          <div class="content">
            <div>{{ webSiteInfo.address }}</div>
          </div>
        </div>
        <div class="flooter_item"></div>
        <div class="flooter_item"></div>
        <div class="flooter_item" v-animate="'fadeIn'">
          <div class="technology">
            <!-- {{ baseLabel["技术支持"][language] }}: 15587883508 -->
          </div>
          <div class="content">
            <div
              class="img"
              @click="
                handelJumpLink(
                  'https://www.instagram.com/angallerie?igsh=eHd6dnh6b3lzdWpt&utm_source=qr'
                )
              "
            >
              <img src="./assets/images/x1.png" alt />
              <!-- <div class="ewm">
                <img src="./assets/images/wx.png" alt="">
              </div>-->
            </div>
            <div
              class="img"
              @click="
                handelJumpLink(
                  'https://www.xiaohongshu.com/user/profile/5fb736b800000000010080b3?xsec_token=YBajZrPtTRLhaZA0yMYUeBWUHP5PfudqsrzwfKjPOJtSM=&xsec_source=app_share&xhsshare=CopyLink&appuid=5fb736b800000000010080b3&apptime=1740480329'
                )
              "
            >
              <img src="./assets/images/x3.png" alt />
              <!-- <div class="ewm">
                <img src="./assets/images/x1.png" alt="">
              </div>-->
            </div>
            <div class="img">
              <img src="./assets/images/x2.png" alt />
              <div class="ewm">
                <!-- <img src="./assets/images/wx.png" alt /> -->
                <img
                  :src="'http://124.223.178.182:8090' + webSiteInfo.wechat"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div>
            <div class="copyRight1">{{ webSiteInfo.copyright }}</div>
            <div class="copyRight1" style="cursor: pointer;margin-top:5px" @click="handelBa">浙ICP备2021036652号-1</div>
          </div>
        </div>
      </div>
      <!-- <div class="copyRight">COPYRIGHT©2025 AN GALLERIE</div> -->
    </div>
  </div>
</template>



<script>
import { listWebSite } from "@/api/index";
export default {
  name: "App",
  data() {
    return {
      searchKey: null,
      openSearch: false,
      isScorll: false,
      flag: 65,
      openMenus: false,
      webSiteInfo: {},
      menus: [
        {
          label: "艺术家",

          path: "/artist",
        },
        {
          label: "展览",

          path: "/exhibition",
        },
        {
          label: "博览会",

          path: "/fairs",
        },
        {
          label: "视野",

          path: "/fov",
        },
        {
          label: "关于",

          path: "/about",
        },
      ],
    };
  },
  created() {
    if (Object.keys(this.$route.query).length != 0) {
      this.openSearch = true;
    }
    this.getWebsite();
  },

  mounted() {
    console.log(window.scrollY, 6666);
    let scrollY = localStorage.getItem("scrollY");
    if (scrollY) {
      scrollY >= this.flag ? true : false;
    }
    this.isScorll = window.scrollY >= this.flag ? true : false;
    window.addEventListener("scroll", (e) => {
      this.handleScroll(e);
    });
    const width = window.innerWidth;
    this.$store.commit("SET_DEVICE", width > 765 ? "PC" : "MOBILE");
    window.addEventListener("resize", (e) => {
      const width = window.innerWidth;
      this.$store.commit("SET_DEVICE", width > 765 ? "PC" : "MOBILE");
    });
    console.log(this.baseLabel);
  },
  computed: {
    device() {
      return this.$store.state.webSite.device;
    },
    language() {
      return this.$store.state.webSite.language;
    },
    baseLabel() {
      return this.$store.state.webSite.baseLabel;
    },
  },
  methods: {
    handelBa(){
      window.open('https://beian.miit.gov.cn/')
    },
    getWebsite() {
      listWebSite({ isEn: this.language }).then((res) => {
        this.webSiteInfo = res.rows.length ? { ...res.rows[0] } : null;
      });
    },
    handelLanguage() {
      this.$store.commit("SET_LANGUAGE", this.language == "CN" ? "EN" : "CN");
      this.getWebsite();
      if (this.device == "MOBILE") {
        this.handelCloseMenus();
      }
    },
    clearSearch() {
      this.searchKey = null;
      this.$refs.searchInput.focus();
    },
    handelSearch() {
      this.$router.push({
        path: "/search?searchKey=" + this.searchKey,
      });
      if (this.device == "MOBILE") {
        this.openMenus = false;
      }
    },
    handelOpenSearch() {
      this.openSearch = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    handelCloseSearch() {
      this.openSearch = false;
      this.$nextTick(() => {
        // this.$refs.searchInput.blur();
      });
    },
    handelOpenMenus() {
      this.openMenus = true;
    },
    handelCloseMenus() {
      this.openMenus = false;
    },
    handelJumpLink(url) {
      window.open(url, "_blank");
    },
    handelJump(url) {
      this.$router.push({
        path: url,
      });
      if (this.device == "MOBILE") {
        this.openMenus = false;
      }
    },
    handleScroll(event) {
      if (window.scrollY >= this.flag) {
        if (this.isScorll) {
          return false;
        }
        localStorage.setItem("scrollY", window.scrollY);
        this.isScorll = window.scrollY >= this.flag ? true : false;
      } else {
        if (!this.isScorll) {
          return false;
        }
        localStorage.setItem("scrollY", window.scrollY);
        this.isScorll = window.scrollY >= this.flag ? true : false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
/* fade-transform */
.fade-transform--move,
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // font-family: "宋体", SimSun, sans-serif;
  font-family: "Trebuchet MS", Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  color: #333333;
  .menus_header {
    width: 100%;
    height: 100px;
    background: #fff;
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    .header_left {
      font-size: 28px;
      cursor: pointer;
      display: flex;
      align-items: center;
      img {
        width: 150px;
        height: 100%;
      }
    }
    .header_search {
      flex: 1;
      display: flex;
      align-items: center;
      .searchMain {
        width: 120px;
        height: 40px;
        box-sizing: border-box;
        border-radius: 50px;
        display: flex;
        align-items: center;
        overflow: hidden;
        // margin-left: 20px;
        transition: all 0.2s;
        padding: 0 10px;
        .icon {
          width: 25px;
          height: 25px;
          cursor: pointer;
          display: flex;
          align-items: center;
          img {
            width: 100%;
          }
        }

        .icon_clear {
          width: 18px;
          height: 18px;
          border: 1px solid #ebe9e9;
          border-radius: 10px;
          line-height: 16px;
          text-align: center;
          box-sizing: border-box;
          font-size: 12px;
          margin-right: 5px;
          cursor: pointer;
          display: none;
        }
        .searchInp {
          // width: 100%;
          flex: 1;
          height: 98%;
          border: none;
          padding-left: 10px;
          box-sizing: border-box;
          &:focus {
            outline: 2px solid transparent; /* Example: Blue outline */
            outline-offset: 2px; /* Example: Slight offset */
          }
        }
        .closeSearch {
          font-size: 26px;
          margin-left: 10px;
          cursor: pointer;
          width: 25px;
          height: 25px;
          text-align: center;
          line-height: 18px;
          box-sizing: border-box;
          border: 1px solid #ccc;
          border-radius: 50%;
        }
      }
      .open {
        width: 280px;
        border: 1px solid #ccc;
        &:hover {
          .icon_clear {
            display: block;
          }
        }
      }
    }
    .search_close {
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
    .menus_list {
      display: flex;
      align-items: center;
      .menus_item {
        padding: 4px 20px;
        box-sizing: border-box;
        font-size: 16px;
        // margin: 0 25px;

        // font-weight: bold;
        // font-weight: bold;
        cursor: pointer;
      }
    }
    .header_icon {
      width: 25px;
      height: 25px;
      cursor: pointer;
      img {
        width: 25px;
        height: 25px;
      }
    }
  }
  @keyframes fadeIn {
    from {
      height: 0;
    }
    to {
      height: 70px;
    }
  }
  @keyframes fadeInMobile {
    from {
      height: 0;
    }
    to {
      height: 60px;
    }
  }
  .menus_headerFixed {
    width: 100%;
    height: 70px;
    background: #fff;
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    position: fixed;
    left: 0;
    top: 0;
    transition: all 1s;
    animation: fadeIn 0.5s forwards;
    .header_left {
      font-size: 28px;
      cursor: pointer;
      display: flex;
      align-items: center;
      img {
        width: 150px;
        height: 100%;
      }
    }
    .header_search {
      flex: 1;
      display: flex;
      align-items: center;
      .searchMain {
        width: 120px;
        height: 40px;
        box-sizing: border-box;
        border-radius: 50px;
        display: flex;
        align-items: center;
        overflow: hidden;
        // margin-left: 20px;
        transition: all 0.2s;
        padding: 0 10px;
        .icon {
          width: 25px;
          height: 25px;
          cursor: pointer;
          display: flex;
          align-items: center;
          img {
            width: 100%;
          }
        }
        .icon_clear {
          width: 18px;
          height: 18px;
          border: 1px solid #ebe9e9;
          border-radius: 10px;
          line-height: 16px;
          text-align: center;
          box-sizing: border-box;
          font-size: 12px;
          margin-right: 5px;
          cursor: pointer;
          display: none;
        }
        .searchInp {
          flex: 1;
          height: 98%;
          border: none;
          padding-left: 10px;
          box-sizing: border-box;
          &:focus {
            outline: 2px solid transparent; /* Example: Blue outline */
            outline-offset: 2px; /* Example: Slight offset */
          }
        }
      }
      .open {
        width: 280px;
        border: 1px solid #ccc;
        &:hover {
          .icon_clear {
            display: block;
          }
        }
      }
    }
    .search_close {
      font-size: 16px;

      font-weight: bold;
      cursor: pointer;
    }
    .menus_list {
      display: flex;
      align-items: center;
      .menus_item {
        padding: 4px 20px;
        box-sizing: border-box;
        font-size: 16px;
        // font-weight: bold;

        cursor: pointer;
      }
    }
    .header_icon {
      width: 25px;
      height: 25px;
      cursor: pointer;
      img {
        width: 25px;
        height: 25px;
      }
    }
  }

  .fade-bottom-enter-top {
    transform: translate(0, 0);
    opacity: 1;
    transition: 1.5s;
  }

  .route_body {
    width: 100%;
    min-height: calc(100vh - 508px);
    // margin-top: 70px;
  }

  @media (max-width: 765px) {
    .route_body {
      width: 100%;
      min-height: calc(100vh - 374px);
      // margin-top: 70px;
    }
    .flooter_body {
      width: 100%;
      margin-top: 40px;
      padding: 0 20px 10px 20px;
      box-sizing: border-box;
      overflow: hidden;
      border-top: 1px solid #cacaca;
      background-color: #333333;
      color: #ffffff;

      .flooter_item {
        width: 100%;
        margin-top: 20px;
        &:nth-child(6) {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          .technology {
            color: #ccc;
            font-size: 11px;
            position: absolute;
            top: -8px;
            left: 50%;
            transform: translate(-50%, 0);
          }
        }
        .title {
          font-size: 14px;
        }
        .content {
          margin-top: 10px;
          font-size: 14px;
          overflow: hidden;
          display: flex;
          flex-wrap: nowrap;
          .img {
            width: 30px;
            height: 30px;
            // float: left;
            margin-right: 10px;
            img {
              width: 100%;
              height: 100%;
              display: inline-block;
            }
            .ewm {
              display: none;
            }
          }
        }
        .copyRight1 {
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-align: right;
          box-sizing: border-box;
        }
      }
    }
  }
  @media (min-width: 765px) {
    .flooter_body {
      width: 100%;
      padding: 10px 20px 0;
      margin-top: 300px;
      box-sizing: border-box;
      background-color: #333333;
      color: #ffffff;

      .flooter {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 10px 0 20px 0;
        .flooter_left {
          display: flex;
          align-items: center;
          font-weight: bold;
          font-size: 14px;
          .item_left {
            margin-right: 15px;
            letter-spacing: 0px;
            height: 20px;
            line-height: 20px;
            padding: 0 5px;
          }
        }
        .flooter_right {
          display: flex;
          align-items: center;
          .item_right {
            width: 18px;
            height: 18px;
            border-radius: 18px;
            background: #2c3e50;
            margin-left: 60px;
          }
        }

        .flooter_item {
          flex: 1;
          box-sizing: border-box;
          opacity: 0;
          transition: all 1.3s;
          // white-space: nowrap;
          // padding: 0 20px;
          &:nth-child(6) {
            white-space: nowrap;
            position: relative;
            .technology {
              position: absolute;
              font-size: 12px;
              color: #ccc;
              bottom: -20px;
              left: 50%;
              right: 30px;
            }
            .title {
              text-align: right;
              padding-right: 30px;
              box-sizing: border-box;
            }
            .content {
              display: flex;
              flex-direction: row-reverse;
            }
            .copyRight1 {
              font-size: 14px;
              overflow: hidden;
              text-align: right;
              padding: 0 30px;
              box-sizing: border-box;
            }
          }
          .title {
            font-size: 14px;
            // font-weight: bold;
          }
          .content {
            margin-top: 10px;
            font-size: 14px;
            // overflow: hidden;
            > div {
              margin-bottom: 5px;
            }
            .img {
              width: 30px;
              height: 30px;
              float: left;
              margin-right: 30px;
              cursor: pointer;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .ewm {
                width: 150px;
                height: 150px;
                position: absolute;
                left: 50%;
                top: 0px;
                transform: translate(-50%, -100%);
                background: #000;
                overflow: hidden;
                opacity: 0;
                transition: all 0.4s;
                padding: 20px;
                z-index: 7;
                border-radius: 10px;
                box-shadow: 0 0 5px #2c3e50;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              &:hover {
                .ewm {
                  opacity: 1;
                }
              }
            }
          }
        }

        .fadeIn {
          opacity: 1;
        }
      }
      .copyRight {
        width: 100%;
        border-top: 1px solid #ccc;
        padding: 0 20px;
        box-sizing: border-box;
        height: 40px;
        line-height: 40px;
        text-align: center;
        // font-weight: bold;
        font-size: 14px;
        letter-spacing: 1px;
      }
    }
  }

  // 移动端样式
  .mobile_menus_header {
    width: 100%;
    height: 60px;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header_left {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 110px;
      }
    }
    .header_right {
      padding: 3px 2px;
      box-sizing: border-box;
      // border: 1px solid #ccc;
      border-radius: 3px;
      cursor: pointer;
      .menus_icon {
        width: 20px;
        height: 25px;

        position: relative;
        &::after {
          content: "";
          display: inline-block;
          width: 20px;
          position: absolute;
          left: 50%;
          top: 50%;
          height: 4px;
          background: #2c3e50;
          transform: translate(-50%, -65%);
        }

        .line_top {
          position: absolute;
          top: 2px;
          left: 50%;
          width: 100%;
          height: 4px;
          background: #2c3e50;
          transform: translate(-50%, -50%);
        }
        .line_bottom {
          position: absolute;
          bottom: 0px;
          left: 50%;
          width: 100%;
          height: 4px;
          background: #2c3e50;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  // 移动端固定头部
  .mobile_menus_header_fixed {
    width: 100%;
    background: #fff;
    height: 60px;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    position: fixed;
    left: 0;
    top: 0;
    transition: all 1s;
    animation: fadeInMobile 0.5s forwards;
    .header_left {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 110px;
      }
    }
    .header_right {
      padding: 3px 2px;
      box-sizing: border-box;
      // border: 1px solid #ccc;
      border-radius: 3px;
      cursor: pointer;
      .menus_icon {
        width: 20px;
        height: 25px;

        position: relative;
        &::after {
          content: "";
          display: inline-block;
          width: 20px;
          position: absolute;
          left: 50%;
          top: 50%;
          height: 4px;
          background: #2c3e50;
          transform: translate(-50%, -65%);
        }

        .line_top {
          position: absolute;
          top: 2px;
          left: 50%;
          width: 100%;
          height: 4px;
          background: #2c3e50;
          transform: translate(-50%, -50%);
        }
        .line_bottom {
          position: absolute;
          bottom: 0px;
          left: 50%;
          width: 100%;
          height: 4px;
          background: #2c3e50;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .fixed_menus_body {
    width: 100%;
    height: 0px;
    z-index: 9;
    transition: all 0.5s;
    background: #fff;
    overflow: hidden;
    box-sizing: border-box;

    position: relative;
    // font-weight: bold;
    padding: 0 20px;
    .mobile_menus_box {
      width: 100%;
      // height: 60%;
      // border-bottom: 1px solid #ccc;
      .mobile_menus_item {
        width: 100%;
        height: 60px;
        line-height: 60px;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .mobile_address {
      width: 100%;
      position: relative;
      .mobile_address_item {
        width: 100%;
        margin-top: 10px;
        .item_title {
          font-size: 14px;
        }
        .content {
          margin-top: 10px;
          font-size: 14px;
          > div {
            margin-bottom: 10px;
          }
        }
      }
    }
    .mobile_flooter {
      width: 100%;
      height: 50px;
      // border-top: 1px solid #ccc;
      position: absolute;
      left: 0;
      bottom: 0;
      opacity: 0;
      transition: all 1s;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .icon {
        width: 25px;
        height: 25px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          &:hover {
            display: block;
          }
        }
        .ewm {
          display: none;
          position: absolute;
          width: 80px;
          height: 80px;
          left: 50%;
          top: 0;
          transform: translate(-50%, -100%);
        }
      }
      .technology {
        position: absolute;
        top: -18px;
        left: 50%;
        transform: translate(-50%, 0);
        font-size: 12px;
        color: #ccc;
      }
    }
    .fadeIn {
      opacity: 1;
    }
  }
  .open_fixed_menus_body {
    height: calc(100vh - 60px);
  }
  .noBorder {
    border: none !important;
  }
}
.fixedHeight {
  height: 100vh !important;
}
</style>
